/**
 * AnalyticsPage React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';

/**
 * AnalyticsPage is just for an iframe right now
 */
export default class AnalyticsPage extends React.Component {

    /*constructor(props) {
        super(props);
    }*/

    render() {
        return (
            <div>
                <iframe src="https://xkcd.com" title={"analytics"} style={{width: "100%", height: "10000px", borderStyle: "none"}}></iframe>
            </div>
        );
    }
}
